module.exports = __webpack_public_path__ + "assets/img/79@3x.79a3d2b9.png";